// /join without a code: the invalid-link state (003 edge case).
import { JoinLandingScreen } from "@/join/JoinLandingScreen";

export default function JoinWithoutCode() {
  return <JoinLandingScreen rawCode="" />;
}
